import React from 'react';

import { AttributeMobile } from './impl/AttributeMobile/AttributeMobile';

export class ExplanationAttributesMobile extends React.Component {
  constructor(props) {
    super(props)
    // this.state = {
    //   attributes: this.props.attributes
    // }
    this.toggleDescription = this.toggleDescription.bind(this);
  }

  // 2do: useCallback
  toggleDescription(pr) {
    const { attr } = pr
    const newAttr = this.props.attributes.map(_ => {
      if (_.short_name === attr.short_name && _.type === attr.type) {
        return attr;
      } else {
        _.isActive = false
      }

      return _;
    })

    const cb = this.props.callbackUpdatedAttributes
    cb && cb({ attributes: newAttr })
  }

  render() {
    return (
      <React.Fragment>
        <p>Тапніть, щоб дізнатися більше</p>
        {this.props.attributes.map((attr, idx) =>
          <AttributeMobile
            key={idx}
            /*  
              attr =          
              {
                "short_name": "3D",
                "name": "3D",
                "type": "format",
                "description": "Cеанс з залученням технологій об’ємного зображення для прихильників видовищних спец ефектів",
                "isActive": true
              } 
            */
            attr={attr}
            toggleDescription={(_attr) => this.toggleDescription(_attr)}
          />
        )}
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/ExplanationAttributesMobile.jsx